<template>
<div class="page auth-page register-page">
	<background-image
		type="interval"
		:interval="20000"
	/>
	<div class="modal-window content">
		<div class="modal-content">
			<grid>
				<img src="@/assets/images/logo.svg" alt="logo" class="logo">
			</grid>
			<social-register />
			<text-separator />
			<grid>
				<grid-item size="1/1">
					<custom-input
						type="text"
						placeholder="Your name"
						inputStyle="light"
					/>
				</grid-item>
			</grid>
			<grid flat>
				<grid-item size="1/2">
					<custom-input
						type="text"
						placeholder="Company"
						inputStyle="light"
					/>
				</grid-item>
				<grid-item size="1/2">
					<custom-input
						type="text"
						placeholder="Job Title"
						inputStyle="light"
					/>
				</grid-item>
			</grid>
			<grid flat>
				<grid-item size="1/2">
					<custom-input
						type="text"
						placeholder="Email address"
						inputStyle="light"
					/>
				</grid-item>
				<grid-item size="1/2">
					<custom-input
						type="text"
						placeholder="Confirm Email"
						inputStyle="light"
					/>
				</grid-item>
			</grid>
			<grid flat>
				<grid-item size="1/2">
					<custom-input
						type="password"
						placeholder="Password"
						inputStyle="light"
					/>
				</grid-item>
				<grid-item size="1/2">
					<custom-input
						type="text"
						placeholder="Confirm Password"
						inputStyle="light"
					/>
				</grid-item>
			</grid>
			<grid>
				<grid-item size="1/1">
					<p class="rule-message">
						<custom-checkbox
							:label="'I have read and agree to the <a>Terms & Conditions</a> and <a>Privacy Policy</a>'"
							checkboxStyle="register-checkbox"
						/>
						
					</p>
					<p class="rule-message">
						<custom-checkbox
							label="Join our mailing list. You can unsubscribe at any time"
							checkboxStyle="register-checkbox"
						/>
						
					</p>
				</grid-item>
			</grid>
			<hr>
			<grid>
				<grid-item size="1/1">
					<router-link to="/questionnaire" class="button primary register-button">Sign up</router-link>
				</grid-item>
			</grid>
		</div>
		<div class="modal-content modal-content-after">
			<h5>Already registered?</h5>
			<router-link to="/login">
				SIGN IN
			</router-link>
		</div>
	</div>
</div>
</template>

<script>
import SocialRegister from './components/SocialRegister'
import TextSeparator from './components/TextSeparator'
import CustomInput from '@/components/secondary/CustomInput'
import CustomCheckbox from '@/components/secondary/CustomCheckbox'
import BackgroundImage from '@/components/main/BackgroundImage'

export default {
	components: {
		SocialRegister,
		TextSeparator,
		CustomInput,
		CustomCheckbox,
		BackgroundImage
	}
	
}
</script>

<style lang="scss">
.register-page {
	.content {
		top: 44% !important;
	}

	.custom-input {
		margin: 0px 5px;
	}
	.rule-message {
		color: #fff;
		font-size: 13px;
		text-align: left;
		margin: 10px 0;

		a {
			text-decoration: underline;
			font-weight: 700;
		}
	}
	
	.register-button {
		margin: 8px 0;
	}
}
</style>
